import { __assign, __extends } from "tslib";
import React from 'react';
import { Image } from '@wix/image';
var WowImageRenderer = /** @class */ (function (_super) {
    __extends(WowImageRenderer, _super);
    function WowImageRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.myRef = React.createRef();
        return _this;
    }
    WowImageRenderer.prototype.componentDidMount = function () {
        var _a;
        if ((_a = this.myRef.current) === null || _a === void 0 ? void 0 : _a.complete) {
            this.props.onLoad();
        }
    };
    WowImageRenderer.prototype.render = function () {
        var props = this.props;
        return React.createElement(Image, __assign({}, props.src));
    };
    return WowImageRenderer;
}(React.Component));
export { WowImageRenderer };
//# sourceMappingURL=WowImageRenderer.js.map